import {Component, OnInit} from "@angular/core";
import {ProcessReport} from "../../../model/reports.model";
import {ViewManagerService} from "../../../services/view-manager.service";
import {SessionManagerService} from "../../../services/session-manager.service";
import {DashboardService} from "../dashboard.service";
import {ChannelsService} from "../../channels/channels-service.service";
import {ScreeningAlert} from "../../../model/lookup-results.model";
import {PipelineState} from "../../../model/machine.model";

@Component({
  selector: "admin-dashboard-pipelines",
  templateUrl: "./pipelines.component.html",
  styleUrls: ["./pipelines.component.css"]
})
export class AdminDashboardPipelinesComponent {

  result: ProcessReport[] = [];

  page: number = 1;
  pageSize: number = 10;

  constructor(
    private dashboardService: DashboardService
  ) {
    const results$ = this.dashboardService.statusesSubject.asObservable();
    results$.subscribe(results => {
      this.page = 1;
      this.paginate();
    });
  }

  report(process: ProcessReport) {
    this.dashboardService.report(process);
  }

  get all() {
    return this.dashboardService.statuses;
  }

  getReports() {
    return this.dashboardService.reports;
  }

  reportStats(name: string, report: ProcessReport) {
    return Number(report?.stats[name]) ?? 0.0000
  }

  statusClass(report: ProcessReport) {
    if (report.status == "SUCCESS") {
      return "success";
    } else if (report.status == "RUNNING") {
      return "running";
    } else if (report.status == "ERRORS") {
      return "errors";
    } else if (report.status == "NEW") {
      return "new";
    }
    return "disabled";
  }

  paginate() {
    this.result = this.dashboardService.statusesSubject.value.map((one, i) => ({ id: i + 1, ...one })).slice(
      (this.page - 1) * this.pageSize,
      (this.page - 1) * this.pageSize + this.pageSize,
    );
  }
}
